import {TYPE} from 'helpers/contacts'
import {get, isNil} from 'lodash'

export const isContactSearchDrawerOpen = state => state.contactsContext.search.drawerOpen
export const isContactSearchShowingDormants = state => state.contactsContext.search.filters.showDormants
export const getContactSearchSearchField = state => state.contactsContext.search.filters.searchField

export const getOpenCompanies = state => state.contactsContext.openCompanies || []
export const getSelectedCurrentTab = state => state.contactsContext.selected.currentTab || 'details'
export const getSelectedCompany = state => state.contactsContext.selected.detailsTab.company
export const getSelectedCompanyId = state => get(state, 'contactsContext.selected.companyId')
export const getSelectedContact = state => state.contactsContext.selected.detailsTab.contact
export const getSelectedContactId = state => get(state, 'contactsContext.selected.contactId')
export const getCompanyFromDetailsTab = state => state.contactsContext.selected.detailsTab.company
export const isContactDetailsLoading = state => state.contactsContext.selected.detailsTab.fetching
export const isShowingClosed = state => state.contactsContext.selected.opportunitiesTab.showClosed
export const isShowAllContactsOpportunities = state => state.contactsContext.selected.opportunitiesTab.showAllContacts

export const isFieldSelectorOpen = state => state.contactsContext.fieldSelectorOpen
export const getFieldSelectMode = state => state.contactsContext.fieldSelectMode

export const canDelete = state => !state.auth.user.proSync

export const getSelectedCompanyContacts = state => state.contactsContext.selected.detailsTab.companyContacts || []

export const getMainContact = state => getSelectedCompanyContacts(state)
  .find(contact => contact.type === TYPE.main)

export const getContactFromSelectedCompany = (state, contactId) => {
  const companyContacts = getSelectedCompanyContacts(state)
  return isNil(contactId)
    ? null
    : companyContacts.find(contact => contact.id === contactId)
}

export const getDefaultEntityId = (state, contactId, companyId, recentContactsKey, recentCompaniesKey, latestKey) => {
  return !isNil(contactId)
    ? getDefaultEntityIdForObject(state, recentContactsKey, 'contact', latestKey, contactId)
    : !isNil(companyId)
      ? getDefaultEntityIdForObject(state, recentCompaniesKey, 'company', latestKey, companyId)
      : null
}

export const getDefaultEntityIdForObject = (state, recentKey, objectKey, latestKey, objectId) => {

  // Recently selected entity for the specified object
  const entityId = state.contactsContext[recentKey][objectId]
  if (!isNil(entityId)) return entityId

  // The latest entity for the specified object
  const object = get(state.contactsContext.selected.detailsTab, objectKey, null)
  const latestEntity = isNil(object) || object.id !== objectId ? null : get(object, latestKey, null)
  return isNil(latestEntity) ? null : latestEntity.id
}

export const isBulkSaving = state => state.contactsContext.isBulkSaving
export const getBulkSaveProgress = state => state.contactsContext.bulkSaveProgress

export const isDeletingCompany = state => state.contactsContext.isDeletingCompany
export const isDeletingContact = state => state.contactsContext.isDeletingContact

export const getLocations = state => state.contactsContext.selected.detailsTab.locations || []
export const isContactDetailsVisible = state => state.contactsContext.selected.isContactDetailsVisible

export const getRecentContacts = state => state.contactsContext.recentContacts

export const isCompanyContactsShowDormants = state => state.contactsContext.selected.companyContacts.showDormants

export const isShowCompletedActivities = state => state.contactsContext.selected.activitiesTab.showCompleted
export const isShowRejectedActivities = state => state.contactsContext.selected.activitiesTab.showRejected
export const isShowAllContactsActivities = state => state.contactsContext.selected.activitiesTab.showAllContacts

export const getSelectedContactDocumentFolders = state => state.contactsContext.selected.documentsTab.folders
export const getSelectedContactDocumentSubFolder = state => state.contactsContext.selected.documentsTab.subFolder
export const getSelectedContactCurrentDocumentFolder = state =>
  state.contactsContext.selected.documentsTab.currentFolder
export const getSelectedContactDocuments = state => state.contactsContext.selected.documentsTab.pivotTable.data.data

export const getSelectedContactNewDocumentsTabDocuments = state =>
  state.contactsContext.selected.newDocumentsTab.pivotTable.data.data
